import React from 'react'
import { connect } from 'react-redux'
import cn from 'classnames'
import { withTranslation } from 'react-i18next'

import {
  getIdentityPendingForStatsBlock,
  getIdentityStage,
  getIdentityActiveProTrackName,
} from 'store/entities/identity/selectors'
import UserBoardActivityStatsCommitDetails from './CommitDetails'
import UserBoardActivityStatsStreakDetails from './StreakDetails'
import UserBoardActivityAndStreakLoader from 'app/domains/common/Loaders/UserBoardActivityAndStreakLoader'
import ProTrackName from 'app/components/ProTrackName/ProTrackName'
import { DONE } from 'app/constants/stages'
import './styles.scss'

const bc = 'activity-and-streak'

const mapStateToProps = state => ({
  pending: getIdentityPendingForStatsBlock(state),
  stage: getIdentityStage(state),
  proTrackName: getIdentityActiveProTrackName(state),
})

const UserBoardActivityAndStreak = ({ t, pending, stage, proTrackName = '' }) => (
  <div className={bc}>
    {stage === DONE &&
      proTrackName !== null && (
        <div className={`${bc}__done-stats`}>
          {t('Your stats for')} <ProTrackName proTrackName={proTrackName} />
        </div>
      )}
    {pending ? (
      <UserBoardActivityAndStreakLoader />
    ) : (
      <div className={cn(`${bc}__parts`, `${bc}__parts-home`)}>
        <UserBoardActivityStatsCommitDetails />
        <UserBoardActivityStatsStreakDetails />
      </div>
    )}
  </div>
)

UserBoardActivityAndStreak.displayName = 'UserBoardActivityAndStreak'

const UserBoardActivityAndStreakContainer = withTranslation('user')(
  connect(mapStateToProps)(UserBoardActivityAndStreak)
)

UserBoardActivityAndStreakContainer.displayName = 'UserBoardActivityAndStreakContainer'

export default UserBoardActivityAndStreakContainer
